import type { OAuthConsentClientResponse, UserSessionSummary } from "@repo/shared/types";
import { del, get } from "./_client";

export type OAuthApp = {
  id: string;
  clientId: string;
  name: string | null;
  icon: string | null;
  scopes: string | null;
  createdAt: string | null;
};

export function getOAuthApps() {
  return get<OAuthApp[]>("/internal/security/oauth-apps");
}

export function revokeOAuthApp(id: string) {
  return del<{ success: boolean }>(`/internal/security/oauth-apps/${id}`);
}

export function getOAuthConsentClient(clientId: string, redirectUri: string) {
  const query = new URLSearchParams({ client_id: clientId, redirect_uri: redirectUri });
  return get<OAuthConsentClientResponse>(`/internal/security/oauth-consent-client?${query}`);
}

export function getTrustDeviceStatus() {
  return get<{ isTrusted: boolean }>("/internal/security/trust-device");
}

export function untrustDevice() {
  return del<{ success: boolean }>("/internal/security/trust-device");
}

export function getUserSessions() {
  return get<UserSessionSummary[]>("/internal/security/sessions");
}
